import { render, staticRenderFns } from "./WhoTrust.vue?vue&type=template&id=43e3923f&scoped=true&"
import script from "./WhoTrust.vue?vue&type=script&lang=js&"
export * from "./WhoTrust.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43e3923f",
  null
  
)

export default component.exports